export class MessagesConstants {
    // Billing Messages
    public static readonly BILLING_UPDATE_PLAN_CONFIRMATION_TITLE = 'Confirmar Atualização de Plano';
    public static readonly BILLING_UPDATE_PLAN_CONFIRMATION_MESSAGE = 'Você tem certeza que deseja atualizar seu plano? A cobrança será ajustada proporcionalmente ao tempo restante do período atual.';
    public static readonly BILLING_UPDATE_PLAN_SUCCESS = 'Plano atualizado com sucesso!';
    public static readonly BILLING_UPDATE_PLAN_ERROR = 'Erro ao atualizar plano';
    public static readonly BILLING_SUBSCRIPTION_DATA_ERROR = 'Erro ao carregar dados da assinatura';
    public static readonly BILLING_SUBSCRIPTION_DATA_UNAVAILABLE = 'Dados da assinatura não disponíveis';
    public static readonly BILLING_PLANS_LOADING_ERROR = 'Erro ao carregar planos';
    public static readonly BILLING_DOWNGRADE_NEXT_CYCLE = 'Este valor será cobrado apenas no próximo ciclo de cobrança';
    public static readonly BILLING_PLAN_LOADING = 'Carregando...';
    public static readonly BILLING_FREE_PLAN = 'Free';
    public static readonly BILLING_FREE_PLAN_DESCRIPTION = 'Você está usando um plano gratuito, considere atualizar para uma versão mais completa...';

    // Plan Keys (for comparisons)
    public static readonly PLAN_KEY_BRONZE = 'bronze';
    public static readonly PLAN_KEY_SILVER = 'silver';
    public static readonly PLAN_KEY_GOLD = 'gold';
    public static readonly PLAN_KEY_DIAMOND = 'diamond';
    public static readonly PLAN_KEY_NO_SUBSCRIPTION = 'no_subscription';

    // Plan Display Names
    public static readonly PLAN_NAME_BRONZE = 'Bronze';
    public static readonly PLAN_NAME_SILVER = 'Prata';
    public static readonly PLAN_NAME_GOLD = 'Ouro';
    public static readonly PLAN_NAME_DIAMOND = 'Diamond';
    public static readonly PLAN_NAME_NO_SUBSCRIPTION = 'Sem Assinatura';

    // Plan Descriptions
    public static readonly PLAN_DESCRIPTION_BRONZE = 'Ideal para igrejas iniciantes com recursos essenciais.';
    public static readonly PLAN_DESCRIPTION_SILVER = 'Perfeito para igrejas em crescimento com recursos avançados.';
    public static readonly PLAN_DESCRIPTION_GOLD = 'Completo para igrejas estabelecidas com todos os recursos.';
    public static readonly PLAN_DESCRIPTION_DIAMOND = 'Flexível e escalável, pague apenas pelos membros cadastrados.';
    public static readonly PLAN_DESCRIPTION_NO_SUBSCRIPTION = 'Nenhuma assinatura ativa encontrada. Assine um plano para desbloquear recursos.';

    // Member Deactivation & Plan Change
    public static readonly MEMBER_DEACTIVATION_SUCCESS = 'Membro desativado com sucesso';
    public static readonly MEMBER_DEACTIVATION_ERROR = 'Erro ao desativar membro';
    public static readonly MEMBER_PLAN_CHANGE_SUGGESTION_TITLE = 'Sugestão de Mudança de Plano';
    public static readonly MEMBER_PLAN_CHANGE_NEXT_CYCLE = 'Esta mudança será aplicada automaticamente no próximo ciclo de cobrança';

    // Confirmation Buttons
    public static readonly BUTTON_YES = 'Sim';
    public static readonly BUTTON_NO = 'Não';
    public static readonly BUTTON_CONFIRM = 'Confirmar';
    public static readonly BUTTON_CANCEL = 'Cancelar';
}
